export const FETCH_ORGANIZATIONS_FAILURE='FETCH_ORGANIZATIONS_FAILURE';
export const FETCH_ORGANIZATIONS_SUCCESS='FETCH_ORGANIZATIONS_SUCCESS';
export const FETCH_ORGANIZATIONS_REQUEST='FETCH_ORGANIZATIONS_REQUEST';

export const fetchOrganizationsRequest = ({ page = 1, limit = 10, search = '' } = {}) => ({
  type: FETCH_ORGANIZATIONS_REQUEST,
  payload: { page, limit, search },
});

export const fetchOrganizationsSuccess = (data) => ({
  type: FETCH_ORGANIZATIONS_SUCCESS,
  payload: data,
});

export const fetchOrganizationsFailure = (error) => ({
  type: FETCH_ORGANIZATIONS_FAILURE,
  payload: error,
});